import { Component, ElementRef, Input, Renderer2 } from '@angular/core';
import {CustomCurrencyPipe} from '../../directives/currency-pipe.directive';
import {Commission} from '../../models';

@Component({
    selector: 'bar-chart',
    templateUrl: './bar-chart.component.html'
})
export class BarChartComponent {
    @Input() commissions: Commission[];

    private legend: any = {display: false, fullWidth: false};

    public barChartOptions: any = {
        responsive: true,
        scaleShowVerticalLines: false,
        animationEasing: "easeOutBounce",
        pointLabelFontSize: 12,
        //maintainAspectRatio: false,
        legend: this.legend,
        lineTension: 0
    };
    public barChartLabels: string[] = ['1', '2', '3'];
    // public barChartType: string = 'bar';
    public barChartLegend: boolean = false;

    public dataset: any[] = [{data: [1, 2, 3]}];

    private bind() {
        if (this.commissions && this.commissions.length > 0) {

            this.commissions.sort((a, b) => {
                if (a.Month < b.Month) {
                    return 1;
                }
                if (a.Month > b.Month) {
                    return -1;
                }
                return 0;
            }).reverse();
            this.barChartLabels = this.commissions.map(c => c.Month.toString());
            this.dataset = [{data: this.commissions.map(c => +c.CommissionAmount)}];
        }
    }

    ngOnInit() {
        this.bind();
    }
}